import { useMemo } from 'react';
import { useExposedToWindow } from '../hooks/useExposedToWindow';
import { ChildrenOnly } from '../types/ChildrenOnly';
import { EventBus } from '../util/EventBus';
import { AnalyticsContext } from './AnalyticsContext';
import { AnalyticsState } from './AnalyticsState';
import { TrackingData } from './TrackingData';

/** Owns the current analytics-state and the analytics event-bus. */

export const AnalyticsProvider = ({ children }: ChildrenOnly) => {
  const context = useMemo(
    (): AnalyticsContext => ({
      state: new AnalyticsState(),
      bus: new EventBus(),
    }),
    [],
  );

  /** Expose the state as window.getAnalyticsData() for third-party tools */
  useExposedToWindow('getAnalyticsData', context.state.build);

  return <AnalyticsContext.Provider value={context}>{children}</AnalyticsContext.Provider>;
};

declare global {
  interface Window {
    getAnalyticsData?(): TrackingData;
  }
}
